module.exports = __webpack_public_path__ + "img/四川天府新区映美幼儿园.4897b2ab.jpg";